<template>
  <div class="wrapper_dark" @click="interactCheck">
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("email_01_title") }}</h1>
      <button class="btn_exit" @click="goHome">{{ $tc("cancle") }}</button>
    </div>
    <div class="inner_wrap">
      <div class="email-input-wrap" :class="{ isFocus }">
        <img v-if="(isActive || isFocus)" src="@/assets/img/light_blue/mail.svg" />
        <img v-else src="@/assets/img/gray_600/mail.svg" />
        <input type="text" placeholder="Email address (ex. address@tabling.co.kr)" maxlength="40" inputmode="email"
          :value="email"
          @input="inputEmail" @focus="() => {this.isFocus = true}" @blur="() => {this.isFocus = false}"/>
      </div>
      <div class="next-btn" :class="{ active: isActive }" @click="next">{{ $tc("next") }}</div>
      <div class="email_notice">
        <div class="email_notice_title">{{ $tc("email_02_notice_title") }}</div>
        <ol class="notice_content">
          <li v-html="$tc('email_03_notice_1')"></li>
          <li v-html="$tc('email_04_notice_2')"></li>
          <li v-html="$tc('email_05_notice_3')"></li>
        </ol>
      </div>
    </div>
    <Popup v-show="showPopup" @popControl="popup" />
    <timeout-popup :isShow="isShowTimeOutPop" @moveToHome="moveToHome" @close="closeTimeoutPopup"/>
  </div>
</template>
<script>
import { timeout } from './mixins/timeout'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import Popup from '@/components/Popup.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Email',
  mixins: [timeout],
  components: { timeoutPopup, Popup },
  computed: {
    ...mapGetters({ restaurant: 'getRestaurantInfo', waitingParams: 'getWaitingParams' })
  },
  data () {
    return {
      email: '',
      isFocus: false,
      showPopup: false,
      isActive: false
    }
  },
  methods: {
    inputEmail (event) {
      this.interactCheck()
      // eslint-disable-next-line
      const regx = /[^(0-9a-zA-Z\{\}\[\]\(\)\/\\?.,;:|*~`!^\-_+<>\#$%&\=\'\“@)]/gi
      event.target.value = event.target.value.replace(regx, '')
      // eslint-disable-next-line
      const regExp =  /[0-9a-zA-Z\{\}\[\]\(\)\/\\?.,;:|*~`!^\-_+<>\#$%&\=\'\“]*@[0-9a-zA-Z\{\}\[\]\(\)\/\\?.,;:|*~`!^\-_+<>\#$%&\=\'\“]*\.[a-zA-Z]{2,}$/g
      if (regExp.test(event.target.value)) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      this.email = event.target.value
    },
    next () {
      if (!this.isActive) return
      const params = {
        email: this.email
      }
      this.$store.commit('setWaitingParams', params)
      this.$router.push('/select-person')
    },
    back () {
      this.$router.push('/bifurcation')
    },
    goHome () {
      this.showPopup = true
    },
    popup (type) {
      if (type === 'cancle') {
        this.$router.push('/')
      } else {
        this.showPopup = false
      }
    }
  },
  mounted () {
    if (this.waitingParams.email !== '') {
      this.email = this.waitingParams.email
      this.isActive = true
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";
.inner_wrap {
  display: block;
  padding: 48px 60px 30px;
  background: $gray_50;
  .email-input-wrap {
    display: flex;
    padding: 18px 24px;
    margin: 0 0 24px 0;
    align-items: center;
    border-radius: 16px;
    border: 2px solid $gray_400;
    background: $white;
    input {
      height: 48px;
      width: 100%;
      margin: 0 0 0 12px;
      border: none;
      font-size: 32px;
      color: $gray_900;
      &:focus {
        outline: none;
      }
    }
    &.isFocus {
      padding: 16px 22px;
      border: 4px solid $light_blue;
    }
  }
  .next-btn {
    display: flex;
    width: 536px;
    height: 112px;
    margin: 0 auto 48px;
    padding: 24px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    border: 3px solid rgba(19, 21, 23, 0.10);
    background: $gray_400;
    font-size: 42px;
    font-weight: 600;
    color: $white;
    cursor: pointer;
    &.active {
      background: $light_blue;
      box-shadow: 0px 6px 12px 0px rgba(0, 145, 255, 0.20);
    }
  }
  .email_notice {
    width: 100%;
    height: 380px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 3px;
    background: $information;
    color: $white;
    font-size: 27px;
    .email_notice_title {
      color: $check;
      padding-bottom: 30px;
      font-size: 27px;
    }
    .notice_content {
      line-height: 1.5;
      margin-block-start: 0;
      margin-block-end: 0;
      li {
        color: $white;
      }
    }
  }
}
</style>
